
import React from 'react';

const LogoIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="logoGradientSmall" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#A855F7" />
        <stop offset="100%" stopColor="#2563EB" />
      </linearGradient>
    </defs>
    <path d="M30 20 H15 V85 H85 V70 M85 45 V30" stroke="url(#logoGradientSmall)" strokeWidth="12" />
    <path d="M35 65 L85 15 M85 15 H55 M85 15 V45" stroke="url(#logoGradientSmall)" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChatMessage = ({ message }) => {
  const isBot = message.role === 'model';

  return (
    <div className={`flex w-full mb-3 ${isBot ? 'justify-start' : 'justify-end'}`}>
      <div className={`flex max-w-[90%] ${isBot ? 'flex-row' : 'flex-row-reverse'} gap-2.5`}>
        {isBot && (
          <div className="w-8 h-8 rounded-xl bg-white border border-gray-100 flex items-center justify-center shrink-0 mt-0.5 shadow-sm">
             <LogoIcon className="w-5 h-5" />
          </div>
        )}
        <div className={`px-4 py-2.5 rounded-2xl shadow-sm text-sm leading-relaxed ${isBot ? 'bg-white border border-gray-100 text-gray-800 rounded-tl-none' : 'bg-blue-600 text-white rounded-tr-none'}`}>
          {message.text ? (
            <div className="whitespace-pre-wrap">
              {message.text}
              {message.isStreaming && <span className="inline-block w-1.5 h-3 bg-blue-400 ml-1 animate-pulse align-middle"></span>}
            </div>
          ) : (
            <div className="flex gap-1 py-1">
              <div className="w-1.5 h-1.5 bg-blue-200 rounded-full animate-bounce"></div>
              <div className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
              <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
